import { Box } from '@hover/blueprint';
import type { ReactNode } from 'react';
import React from 'react';

import { useIsSharedView } from 'src/modules/renderings/hooks';
import {
  FocusedViewProvider,
  RenderingHubProvider,
  RenderingSharedProvider,
} from 'src/modules/renderings/provider';
import { RenderingSelectionProvider } from 'src/modules/renderings/provider/RenderingSelection/RenderingSelection';
import { isMobileApp } from 'src/shared/helpers/environment';

import { Header } from './Header';
import { Main } from './Main';
import { Title } from './Title';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const isSharedView = useIsSharedView();
  const Provider = isSharedView
    ? RenderingSharedProvider
    : RenderingHubProvider;

  return (
    <Provider>
      <RenderingSelectionProvider>
        <FocusedViewProvider>
          <Title />
          <Box flexDirection="column" height="100vh" width="100%">
            {!isMobileApp() && <Header routeKey="PROPERTIES" />}
            <Main>{children}</Main>
          </Box>
        </FocusedViewProvider>
      </RenderingSelectionProvider>
    </Provider>
  );
};

export { Layout };
